module.exports = __webpack_public_path__ + "static/media/Caucasus_International_University.b26ad865.jpg";